import React, { ReactNode } from 'react';

import './lesson-banner-view__image-container.scss';

interface Props {
    children: ReactNode | ReactNode[];
}

export const LessonBannerImageContainer = React.memo(({ children }: Props) => {
    return <div className="lesson-banner-view__image-container">{children}</div>;
});
